<template>
  <div data-tour-id="samples-register-template-details-summary">
    <div class="summary-header">
      <div class="summary-title">
        <div class="summary-icon-templates"></div>
        <div class="summary-text">
          {{ title }}
        </div>
      </div>
      <div
        class="summary-actions"
        data-tour-id="samples-register-template-details-actions"
      >
        <!-- <button
          v-if="showUploadButton"
          class="summary-action-button"
          type="button"
          :title="uploadTooltip"
          @click="$emit('register-template')"
        >
          <img :src="iconUpload" :alt="uploadTooltip" />
        </button> -->
        <f7-button
          class="botones-registrar color-green whiteFontColor margin-left button-primary"
          data-tour-id="samples-register-template-details-load-button"
          fill
          outline
          type="default"
          styling-mode="contained"
          name="Cargar plantilla"
          @click="$emit('register-template')"
        >
          {{ $t('loadTemplate') }}
        </f7-button>
        <!-- <button
          v-if="showEditButton"
          class="summary-action-button"
          type="button"
          :title="editTooltip"
          @click="$emit('edit')"
        >
          <img :src="iconEdit" :alt="editTooltip" />
        </button> -->

        <f7-button
          class="botones-registrar color-green whiteFontColor button-primary"
          data-tour-id="samples-register-template-details-edit-button"
          fill
          outline
          type="default"
          styling-mode="contained"
          name="editar plantilla"
          @click="$emit('edit')"
        >
          {{ $t('editTemplate') }}
        </f7-button>
      </div>
    </div>

    <div class="tableContainerDetails">
      <div class="item-title-bold no-margin no-padding"></div>

      <f7-row class="card-body summary-fields">
        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ descriptionLabel }}
              </div>
              <div class="item-title-bold value-text">
                {{ description }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col class="col-medium-width">
          <f7-row>
            <f7-col v-if="showBudget">
              <div class="label-strong">
                {{ budgetLabel }}
              </div>
              <div class="item-title-bold value-text">
                {{ budget }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col class="col-min-width">
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ statusLabel }}
              </div>
              <div class="item-title-bold value-text">
                {{ status }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col class="col-min-width">
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ createdByLabel }}
              </div>
              <div class="item-title-bold value-text">
                {{ createdBy }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col class="col-min-width">
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ updatedAtLabel }}
              </div>
              <div class="item-title-bold value-text">
                {{ updatedAt }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script>
import iconEdit from '@/static/icons/ic_edit_new.svg';
import iconUpload from '@/static/icons/ic_upload_new.svg';

export default {
  name: 'TemplateDetailsSummary',
  props: {
    title: {
      type: [String, Number],
      default: '-',
    },
    descriptionLabel: {
      type: String,
      default: '',
    },
    description: {
      type: [String, Number],
      default: '-',
    },
    statusLabel: {
      type: String,
      default: '',
    },
    status: {
      type: [String, Number],
      default: '-',
    },
    createdByLabel: {
      type: String,
      default: '',
    },
    createdBy: {
      type: [String, Number],
      default: '-',
    },
    budgetLabel: {
      type: String,
      default: '',
    },
    budget: {
      type: [String, Number],
      default: '-',
    },
    showBudget: {
      type: Boolean,
      default: true,
    },
    updatedAtLabel: {
      type: String,
      default: '',
    },
    updatedAt: {
      type: [String, Number],
      default: '-',
    },
  },
  computed: {
    editTooltip() {
      return this.$t('edit') !== 'edit' ? this.$t('edit') : 'Editar';
    },
    uploadTooltip() {
      return this.$t('registerSample') !== 'registerSample'
        ? this.$t('registerSample')
        : 'Registrar muestra';
    },
  },
  data() {
    return {
      iconEdit,
      iconUpload,
    };
  },
};
</script>

<style scoped>
.summary-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}

.summary-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.summary-icon-templates {
  width: 24px;
  height: 24px;
  background-image: url('@/static/icons/Document.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.summary-text {
  font-size: 18px;
  font-weight: 600;
  color: #00346a;
}

.summary-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.summary-action-button {
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.summary-action-button img {
  width: 14px;
  height: 14px;
}

.summary-action-button:hover {
  opacity: 0.8;
}

/* Mismo estilo base usado en OfferListSummary */
.label-strong {
  color: var(--Primary-Blue-70, #00346a);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
}

.value-text {
  color: var(--Neutral-70, #3e3c44);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

.tableContainerDetails {
  padding: 16px 24px !important;
  border-radius: 10px;
  background: var(--Neutral-10, #f7f7f8) !important;
  border: 1px solid var(--Neutral-20, #e0e0e0);
}

.tableContainerDetails .card-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 24px;
  margin: 0;
}

.tableContainerDetails .summary-fields > .col {
  flex: 1 1 220px;
  width: auto;
  min-width: 0;
}

.tableContainerDetails .summary-fields > .col:first-child {
  flex-basis: 280px;
}

.col-min-width {
  min-width: 180px !important;
}

.col-medium-width {
  min-width: 240px !important;
}

@media (max-width: 768px) {
  .tableContainerDetails .card-body {
    gap: 16px;
  }

  .tableContainerDetails .summary-fields > .col {
    flex: 1 1 100%;
    min-width: 100%;
  }
}
</style>
